(function(window, document, $) {
    if (!$) {
        console.error('jQuery is not loaded');
        return;
    }

    var jhPrint = {
        // Initialize the print functionality
        init: function() {

            // Use event delegation to handle dynamically added elements
            $(document).on('click', '#share-print', function() {
                window.print(); // Trigger the print dialog
                return false;
            });

            // Add beforeprint and afterprint event listeners
            window.addEventListener('beforeprint', function() {
                // Lazy load images
                $('img[data-src]').each(function() {
                    var $img = $(this);
                    $img.attr('src', $img.data('src'));
                    $img.removeAttr('data-src');
                });

                // Apply custom print styles
                $('body').addClass('print-mode');
            });

            window.addEventListener('afterprint', function() {
                // Remove custom print styles
                $('body').removeClass('print-mode');
            });
        }
    };

    // Initialize the print functionality when the document is ready
    $(document).ready(function() {
        jhPrint.init();
    });
})(window, document, jQuery);